import type { SortBy } from '@/components/molecules/SortByDropdown';
import type { OverviewLocation } from '@/domain/client';
import type { LocationsLicenseOverview } from '@/domain/licenses';
import { locationDashboardPath, usePreferredDashboardView } from '@/hooks/useLocationDashboardUrl';

import LocationOverviewBox from './LocationOverviewBox';

import styles from '../RegionOverview.module.scss';

interface SortedLocationsProps {
    locations: OverviewLocation[];
    locationLicenses: LocationsLicenseOverview[];
    isActive?: boolean;
    clientId: number;
    hasAccessToMarkHistorical: boolean;
    markHistorical: (cageId: number, historical: boolean) => Promise<unknown>;
    isOptoScaleAdmin?: boolean;
    renderLazy?: boolean;
    sortForLocation: (locationId: number) => SortBy;
    onLocationSortChange: (locationId: number, next: SortBy) => void;
}

export default function SortedLocations(props: SortedLocationsProps) {
    const {
        locations,
        locationLicenses,
        hasAccessToMarkHistorical,
        clientId,
        markHistorical,
        isOptoScaleAdmin = false,
        renderLazy = false,
        isActive = true,
        sortForLocation,
        onLocationSortChange,
    } = props;
    const defaultView = usePreferredDashboardView();
    const getLocationUrl = (locationId: number) =>
        locationDashboardPath(`/c/${clientId}/location/${locationId}`, defaultView);

    if (!locations.length) {
        return null;
    }

    return (
        <div className={styles.locationListContainer}>
            {locations.map((location) => {
                const locationLicense = locationLicenses.find(
                    (license) => license.locationId === location.locationId
                );
                return (
                    <div key={location.locationId} id={location.locationName.replace(/\s+/g, '')}>
                        <LocationOverviewBox
                            location={location}
                            locationLicense={locationLicense}
                            clientId={clientId}
                            hasAccessToMarkHistorical={hasAccessToMarkHistorical}
                            markHistorical={markHistorical}
                            isActive={isActive}
                            isOptoScaleAdmin={isOptoScaleAdmin}
                            renderLazy={renderLazy}
                            sortBy={sortForLocation(location.locationId)}
                            onSortChange={(next) => onLocationSortChange(location.locationId, next)}
                            locationUrl={getLocationUrl(location.locationId)}
                        />
                    </div>
                );
            })}
        </div>
    );
}
